class DictionaryItem {
    dictionaryType : string = "";
    code : string = "";
    description : string = "";
    additionalDesc : string = "";
    city: string = "";
    street: string = "";
    zip: string = "";
    redirectionUrl: string = "";
}

export default DictionaryItem;